<template>
  <!-- Modal Despacho a Provincia -->
  <div
    class="modal fade"
    id="provincia"
    tabindex="-1"
    role="dialog"
    aria-labelledby="provincia"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-body text-center modal-contenido">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <template v-if="selectDeliveryStep == 1">
            <h3>Aviso</h3>
            <p>
              Estimado Cliente, ha seleccionado una zona de despacho fuera de Lima Metropolitana
              (LM), debe seleccionar la agencia de transporte en la que realizará el envío.
            </p>
            <p>¿Desea continuar con su compra?</p>
            <div class="text-center">
              <button type="button" class="btn btn-primary" @click="selectDeliveryStep = 2">
                Si
              </button>
              <button type="button" class="btn btn-primary" @click="selectDeliveryStep = 4">
                No
              </button>
            </div>
          </template>
          <template v-if="selectDeliveryStep == 2">
            <h3>Seleccione empresa de transporte</h3>
            <br />
            <div class="row sin-padding">
              <div class="col-sm-12">
                <form @submit="searchAgency()">
                  <div class="form-group">
                    <div class="row sin-padding">
                      <div class="col-sm-10">
                        <input
                          v-model="searchAtributte"
                          class="form-control"
                          id="elementsAppendButton"
                          type="text"
                          placeholder="Ingrese el ruc o el nombre de agencia que desea buscar"
                          required
                          maxlength="60"
                        />
                      </div>
                      <div class="col-sm-2">
                        <button class="btn btn-primary" type="button" @click="searchAgency()">
                          Buscar
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="container">
              <div id="accordion" class="acordeon" v-if="transportAgencyAddressList.length > 0">
                <div
                  class="card card-guide"
                  v-for="(item, index) in transportAgencyAddressList"
                  :key="index"
                >
                  <div class="card-header" :id="'heading' + index">
                    <button
                      :class="index == 0 ? 'btn btn-link' : 'btn btn-link collapsed'"
                      data-toggle="collapse"
                      :data-target="'#collapse' + index"
                      aria-expanded="true"
                      :aria-controls="'#collapse' + index"
                    >
                      <h5 class="mb-0">{{ item.transport_agency_name }}</h5>
                      <span class="material-icons">expand_less</span>
                    </button>
                  </div>

                  <div
                    :id="'collapse' + index"
                    :class="index == 0 ? 'collapse show' : 'collapse'"
                    :aria-labelledby="'#heading' + index"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <ul class="list-group">
                        <li
                          v-for="(item_direccion, index2) in item.address_list"
                          :key="index2"
                          class="list-group-item"
                          @click="goToTheStepThree(item_direccion, item.ruc_agency)"
                          style="text-align: left;"
                        >
                          <span style="text-align: left;">{{
                            ' Ubicación: LIMA, LIMA, ' +
                              item_direccion.id_district.desc_district +
                              ', ' +
                              item_direccion.address +
                              ' '
                          }}</span
                          ><a
                            style="color: blue; text-align: right;"
                            @click="goToTheStepThree(item_direccion, item.ruc_agency)"
                            >Seleccionar</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div style="float: left; padding-right: calc(0.5%);">
                  <small>Mostrando pagina {{ currentPage }} de {{ finalPage }}</small>
                </div>
                <!-- Paginado -->
                <div style="float: right; padding-right: calc(0.5%);">
                  <nav>
                    <ul
                      role="menubar"
                      aria-disabled="false"
                      aria-label="Pagination"
                      class="pagination b-pagination pagination-sm"
                    >
                      <template v-if="currentPage == 1">
                        <li role="none presentation" class="page-item disabled">
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span aria-hidden="true" class="page-selector">«</span></a
                          >
                        </li>
                      </template>
                      <template v-else>
                        <li
                          role="none presentation"
                          class="page-item"
                          @click="getHomeDeDeliveryOptionsPage(1)"
                        >
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span aria-hidden="true" class="page-selector">«</span></a
                          >
                        </li>
                      </template>
                      <template v-if="currentPage > 1">
                        <li
                          role="none presentation"
                          class="page-item"
                          aria-hidden="true"
                          @click="getHomeDeDeliveryOptionsPage(currentPage - 1)"
                        >
                          <span class="page-link page-selector">‹</span>
                        </li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item disabled" aria-hidden="true">
                          <span class="page-link page-selector">‹</span>
                        </li>
                      </template>
                      <li
                        v-for="page in pages"
                        :key="page"
                        role="none presentation"
                        :class="['page-item', page === currentPage ? 'active' : '']"
                        @click="getHomeDeDeliveryOptionsPage(page)"
                      >
                        <a
                          role="menuitemradio"
                          tabindex="-1"
                          aria-label="Goto page 2"
                          aria-checked="false"
                          aria-posinset="2"
                          aria-setsize="4"
                          target="_self"
                          class="page-link page-selector"
                          >{{ page }}</a
                        >
                      </li>
                      <template v-if="currentPage == finalPage">
                        <li role="none presentation" class="page-item disabled">
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span aria-hidden="true" class="page-selector">›</span></a
                          >
                        </li>
                      </template>
                      <template v-else>
                        <li
                          role="none presentation"
                          class="page-item"
                          @click="getHomeDeDeliveryOptionsPage(currentPage + 1)"
                        >
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span aria-hidden="true" class="page-selector">›</span></a
                          >
                        </li>
                      </template>
                      <template v-if="currentPage == finalPage">
                        <li role="none presentation" class="page-item disabled">
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span class="page-selector" aria-hidden="true">»</span></a
                          >
                        </li>
                      </template>
                      <template v-else>
                        <li
                          role="none presentation"
                          class="page-item"
                          @click="getHomeDeDeliveryOptionsPage(finalPage)"
                        >
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span class="page-selector" aria-hidden="true">»</span></a
                          >
                        </li>
                      </template>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </template>
          <template v-if="selectDeliveryStep == 3">
            <h3>Despacho en agencia de transporte</h3>
            <p>Elija el día de su preferencia.</p>

            <div class="lugar-hora-precio table-responsive">
              <table class="table table-bordered">
                <thead class="thead-gris">
                  <tr>
                    <th scope="col">
                      <small><strong>Horario</strong></small>
                    </th>
                    <th
                      scope="col"
                      v-for="(item, index) in homeDeliveryOptions.weekOne"
                      :key="index"
                      @click="selectDeliveryOptions(item, selectedAddressDesc)"
                    >
                      <small>
                        {{ item.delivery_date | esDatewName }}
                      </small>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row"><small>09:00 a 19:00 hrs</small></th>

                    <td v-for="(item, index) in homeDeliveryOptions.weekOne" :key="index">
                      {{ item.delivery_cost == 0 ? 'GRATIS' : 'S/ ' + item.delivery_cost }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">-</th>

                    <td v-for="(item, index) in homeDeliveryOptions.weekOne" :key="index">
                      <a
                        href
                        data-dismiss="modal"
                        @click="selectDeliveryOptions(item, selectedAddressDesc)"
                        ><small>Seleccionar</small></a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="lugar-hora-precio table-responsive">
              <table class="table table-bordered">
                <thead class="thead-gris">
                  <tr>
                    <th scope="col">
                      <small><strong>Horario</strong></small>
                    </th>
                    <th
                      scope="col"
                      v-for="(item, index) in homeDeliveryOptions.weekTwo"
                      :key="index"
                      @click="selectDeliveryOptions(item, selectedAddressDesc)"
                    >
                      <small>
                        {{ item.delivery_date | esDatewName }}
                      </small>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row"><small>09:00 a 19:00 hrs</small></th>

                    <td v-for="(item, index) in homeDeliveryOptions.weekTwo" :key="index">
                      {{ item.delivery_cost == 0 ? 'GRATIS' : 'S/ ' + item.delivery_cost }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">-</th>

                    <td v-for="(item, index) in homeDeliveryOptions.weekTwo" :key="index">
                      <a
                        href
                        data-dismiss="modal"
                        @click="selectDeliveryOptions(item, selectedAddressDesc)"
                        ><small>Seleccionar</small></a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template v-if="selectDeliveryStep == 4">
            <h3>Advertencia</h3>
            <p>
              Estimado Cliente, para completar su compra puede comunicarse con: Blanca Aguilar al
              998365524 o escribir a baguilar@frutarom.com que gustosamente lo atenderá para que
              complete su compra.
            </p>
            <div class="text-center">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                Aceptar
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import { config_settings } from '@/config.js';
import {
  getTransportAgencyAddress,
  postSearchTransportAgencyAddress,
  getHomeDeliverysOptions,
  getTransportAgencyAddressPaginate,
} from '@/service/delivery.service.js';
import { generateRefreshTokenBodyRequest, getAccessToken } from '@/helpers/localStorage.helpers';
import { NOT_FOUND, BAD_REQUEST, CONFLICT, UNAUTHORIZED } from '@/types/httpd.constants';

export default {
  name: 'HomeDeliveryOtherPlaces',
  props: ['selectedAddressDesc', 'totalValue'],
  data() {
    return {
      transportAgencyAddressList: [],
      selectDeliveryStep: 1,
      searchAtributte: '',
      pages: [],
      finalPage: 1,
      currentPage: 1,
      homeDeliveryOptions: [],
    };
  },
  methods: {
    getHomeDeliveryOptions() {
      getTransportAgencyAddress(getAccessToken())
        .then((response) => {
          this.transportAgencyAddressList = response.data.transport_agency_address;
          this.pages = response.data.visible_pages;
          this.finalPage = response.data.final_page;
          this.currentPage = page;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.$parent
              .refreshToken()
              .then((_) => {
                this.getHomeDeliveryOptions();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.$router.push({ path: '/inicio' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    searchAgency() {
      postSearchTransportAgencyAddress(this.searchAtributte, getAccessToken())
        .then((response) => {
          this.transportAgencyAddressList = response.data.transport_agency_address;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.$parent
              .refreshToken()
              .then((_) => {
                this.searchAgency();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.$router.push({ path: '/inicio' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    selectDeliveryOptions(item, place) {
      this.$parent.selectDeliveryOtherPlaces(
        item.id_delivery,
        'Despacho a domicilio',
        place,
        item.delivery_cost,
        item.delivery_date,
      );
    },

    goToTheStepThree(item_direccion, ruc) {
      this.selectDeliveryStep = 3;
      var json_address = item_direccion;
      localStorage.setItem('transport_address_details', JSON.stringify(json_address));
      localStorage.setItem('transport_ruc', ruc);
      this.getDeliverysToAgency(item_direccion.id_district.id_district);
    },

    getDeliverysToAgency(idDistrict) {
      getHomeDeliverysOptions(idDistrict, this.totalValue)
        .then((response) => {
          this.homeDeliveryOptions = response.data;
        })
        .catch((error) => {});
    },

    getHomeDeDeliveryOptionsPage(page) {
      getTransportAgencyAddressPaginate(page, 5, getAccessToken())
        .then((response) => {
          this.transportAgencyAddressList = response.data.transport_agency_address;
          this.pages = response.data.visible_pages;
          this.finalPage = response.data.final_page;
          this.currentPage = page;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.$parent
              .refreshToken()
              .then((_) => {
                this.getHomeDeDeliveryOptionsPage(page);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.$router.push({ path: '../../../login/' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },
  },
  created() {
    this.getHomeDeliveryOptions();
  },
};
</script>
